import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LessorsService, LessorVm } from 'src/app/api';
import { CombinedStore } from 'src/app/core/combined.store';
import { LessorType } from 'src/app/shared/enum/housing.enum';

export const lessorResolver: ResolveFn<LessorVm[]> = () => {
  const lessorService = inject(LessorsService);
  const store = inject(CombinedStore);

  const postalCode = store.declaration.address()?.addressAutocomplete?.zipCode ?? store.declaration.address()?.zipCode;

  return lessorService.apiLessorsGetWithZipCode(postalCode!).pipe(
    map((lessors: LessorVm[]) => {
      const lessorsWithEmail = lessors
        .map((lessor) => ({
          ...lessor,
          email: lessor.email?.trimEnd() ?? null,
        }))
        .filter((lessor) => !!lessor.email)
        .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));

      return [
        ...lessorsWithEmail,
        {
          id: LessorType.Other,
          name: 'Autre',
          email: null,
          lessorType: LessorType.Other,
        },
      ];
    }),
    catchError((err: Error) => {
      console.error('Failed to load lessors', err);
      return of([]);
    }),
  );
};
